"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M6.513 20a.5.5 0 0 0-.353.854l3.182 3.175-6.988 6.987a.5.5 0 0 0 0 .707l1.923 1.923a.5.5 0 0 0 .707 0l6.991-6.991 3.172 3.166a.5.5 0 0 0 .853-.354V20zm22.974-4a.5.5 0 0 0 .353-.854l-3.182-3.175 6.988-6.988a.5.5 0 0 0 0-.707l-1.922-1.922a.5.5 0 0 0-.707 0l-6.992 6.99-3.171-3.165a.5.5 0 0 0-.854.354V16z" })
);

